export default "<mat-toolbar>\r\n  <span class=\"fill\"></span>\r\n  <span class=\"small\">© 2018 GB Environmental Trading Pty Ltd</span>\r\n</mat-toolbar>"